import { createAsyncThunk } from '@reduxjs/toolkit'

import { BenefitGroup, COMMON_MIXPANEL_PAGE } from '@lyrahealth-inc/shared-app-logic'

import { axiosInstance } from '../../common/http/axiosInstance'

export const GET_ALL_BENEFITS_FOR_USER = 'GET_ALL_BENEFITS_FOR_USER'
export const GET_RECOMMENDED_BENEFITS_FOR_USER = 'GET_RECOMMENDED_BENEFITS_FOR_USER'

export const getAllBenefitsForUser = createAsyncThunk<BenefitGroup[], string>(
  GET_ALL_BENEFITS_FOR_USER,
  async (userLyraId: string) => {
    try {
      const response = await axiosInstance.get(`/v1/user/${userLyraId}/benefits`)
      return response.data
    } catch (e) {
      console.error(e)
    }
  },
)

export const getRecommendedBenefitsForUser = createAsyncThunk<BenefitGroup[], string>(
  GET_RECOMMENDED_BENEFITS_FOR_USER,
  async (userLyraId: string) => {
    try {
      const response = await axiosInstance.get(`/v1/user/${userLyraId}/benefit-recommendations`)
      return response.data
    } catch (e) {
      console.error(e)
    }
  },
)

export const GET_ALL_BENEFITS_FOR_USER_fulfilled = getAllBenefitsForUser.fulfilled.type
export const GET_RECOMMENDED_BENEFITS_FOR_USER_fulfilled = getRecommendedBenefitsForUser.fulfilled.type

export const SET_INTEGRATED_BENEFITS_ENTRY_POINT = 'SET_INTEGRATED_BENEFITS_ENTRY_POINT'
export const CLEAR_INTEGRATED_BENEFITS_ENTRY_POINT = 'CLEAR_INTEGRATED_BENEFITS_ENTRY_POINT'

export const setIntegratedBenefitsEntryPoint = (entryPoint: COMMON_MIXPANEL_PAGE) => {
  return (dispatch: $TSFixMe) => {
    dispatch({
      type: SET_INTEGRATED_BENEFITS_ENTRY_POINT,
      data: entryPoint,
    })
  }
}

export const clearIntegratedBenefitsEntryPoint = () => ({
  type: CLEAR_INTEGRATED_BENEFITS_ENTRY_POINT,
})
